import React from 'react';

const ExportIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24">
    <path d="M5 16v4h14v-4h2v4c0 1-.8 2-1.9 2H5a2 2 0 01-2-2v-4h2zm8-14v11l3.5-3.5L18 11l-6 6-6-6 1.5-1.5L11 13V2h2z" />
  </svg>
);

export default ExportIcon;
